module.exports = __webpack_public_path__ + "static/img/m_name.c6cae99.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/tsz/m_name.png
// module id = 2KaD
// module chunks = 7